import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  getCheckListInsert,
  getCheckListInsertResponseClear,
  getLearningPathBroker,
  getLearningPathBrokerClear,
  getUnAssginedOBLP,
  setFavoriteCourses,
} from "../../redux/courses/actions";
import { convertTimeFormat, SessionKeys } from "../../utils/AppUtils";
import { ProgressBar } from "react-bootstrap";
import SliderCourseListing from "../LearningPaths/SliderCourseListing";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import Loader from "../Loader/Loader";
import ShimmerCardBody from "../Layouts/ShimmerCardBody";
import OnBoardingPageSection from "../LearningPaths/OnBoardingPageSection";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import "./OnboardingSectionBroker.scss";
import { useTranslation } from "react-i18next";

const OnBoardingSectionBroker = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const learningPathBroker = useSelector(
    (state) => state.courses.learningPathBroker
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const insertCheckList = useSelector((state) => state.courses.checkListInsert);
  const [onBoardingData, setOnBoardingData] = useState([]);
  const [pageType, setPageType] = useState("course");
  const [closeChildModal, setCloseChildModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [apiCalled, setApiCalled] = useState(false);
  const [newCardData, setNewCardData] = useState([]);

  const [noData, setNoData] = useState(false);
  const [isAllCompleted, setIsAllCompleted] = useState(false);
  useEffect(() => {
    if (!_.isEmpty(authBroker) && props.hideLine) {
      if (authBroker?.payload?.user?.broker_id && props.fetchData) {
        setIsLoading(true);
        getAssignedOBLP();
        setTimeout(() => {
          getUnAssignedOBLP();
        }, 2000);
      }
    }
  }, [dispatch, authBroker, props.hideLine, props.fetchData]);

  useEffect(() => {
    if (!_.isEmpty(insertCheckList)) {
      dispatch(getCheckListInsertResponseClear());
    }
  }, [insertCheckList]);

  useEffect(() => {
    // console.log('Action Path broker', learningPathBroker)
    if (!_.isEmpty(learningPathBroker)) {
      if (
        learningPathBroker.status === "success" &&
        _.isArray(learningPathBroker.payload.payload)
      ) {
        const learningData = _.cloneDeep(learningPathBroker.payload.payload);
        // console.log('learningPath', learningData)
        let newLearningList = [];

        for (let learning of learningData) {
          let sendFlag = false;
          console.log("Learning", sendFlag, learning);
          if (learning.is_onboarding) {
            // console.log('setLearningPathData', learning)
            let courseCount = learning.courseList.length;
            let completedCourseCount = 0;
            for (let [index, course] of learning.courseList.entries()) {
              learning.is_manager_checklist = false;
              let currentCourse = course;
              let nextCourse = learning.courseList[index + 1];
              if (learning.sequence === 1) {
                if (index === 0) {
                  currentCourse.isLock = false;
                }
                currentCourse.isLock =
                  currentCourse.isLock === false ? currentCourse.isLock : true;
                if (currentCourse.crs_progress > 0) {
                  // currentCourse.isLock = false;
                  if (index !== learning.courseList.length - 1) {
                    nextCourse.isLock =
                      _.toNumber(currentCourse.crs_progress) >= 100 &&
                      !currentCourse.isLock
                        ? false
                        : true;
                  }
                }
              } else {
                currentCourse.isLock = currentCourse.isLock
                  ? currentCourse.isLock
                  : false;
              }
              currentCourse.duration =
                currentCourse?.entity_type === "video"
                  ? convertTimeFormat(_.toNumber(currentCourse.duration), true)
                  : convertTimeFormat(_.toNumber(currentCourse.duration));
              currentCourse.durationUnit = "";
              // console.log("detaiiii", course)
              if (index < learning.courseList.length - 1) {
                if (
                  !currentCourse?.is_checklist_approved &&
                  currentCourse?.is_checklist_present
                ) {
                  nextCourse.isLock =
                    nextCourse.crs_progress <= 100 ? true : false;
                } else if (
                  currentCourse?.is_checklist_approved &&
                  currentCourse?.is_checklist_present
                ) {
                  nextCourse.isLock = false;
                }

                if (currentCourse.is_checklist_present) {
                  learning.is_manager_checklist = true;
                  nextCourse.is_manager_checklist = true;
                  console.log(
                    "HI",
                    currentCourse.is_checklist_present,
                    nextCourse
                  );
                }
              }
              if (
                !currentCourse?.is_checklist_approved &&
                currentCourse?.is_checklist_present &&
                !sendFlag
              ) {
                if (
                  currentCourse.crs_progress >= 100 &&
                  !currentCourse.isLock &&
                  index !== learning.courseList.length - 1
                ) {
                  console.log(
                    getCheckListInsert({
                      module: "checklist-insert",
                      postData: {
                        token: localStorage.getItem(
                          SessionKeys.API_TOKEN_BROKER
                        ),
                        lp_id: learning?.id,
                        entity_id:
                          currentCourse.source === "broker"
                            ? currentCourse.id
                            : currentCourse?.crscd,
                        entity_type: !currentCourse?.is_level
                          ? "course"
                          : "level",
                      },
                    })
                  );
                  dispatch(
                    getCheckListInsert({
                      module: "checklist-insert",
                      postData: {
                        token: localStorage.getItem(
                          SessionKeys.API_TOKEN_BROKER
                        ),
                        lp_id: learning?.programID,
                        entity_id:
                          currentCourse.source === "broker"
                            ? currentCourse.id
                            : currentCourse?.crscd,
                        entity_type: !currentCourse?.is_level
                          ? "course"
                          : "level",
                      },
                    })
                  );
                  sendFlag = true;
                }
              }
            }
            for (let record of learning.courseList) {
              let checklistArray = [];
              record.clInfo = {};
              if (
                record.is_checklist_present &&
                !_.isEmpty(record.checklist_data) &&
                !_.isEmpty(record.checklist_data.checklist_title)
              ) {
                // alert(JSON.stringify(record.checklist_data.checklist_title))
                checklistArray = record.checklist_data.checklist_title;
                let clData = record.checklist_data;
                record.clInfo = {
                  lp_name: clData.prgm_nm,
                  course_or_level: clData.type,
                  course_name: clData.crs,
                  course_completion_date: clData.course_completion_date
                    ? clData.course_completion_date
                    : "",
                  rea_name: clData.user_name,
                  title_array: checklistArray,
                };
                // if (learning.id == 16548) alert(JSON.stringify(record))
              }
            }

            newLearningList.push(learning);
          }
        }
        console.log(newLearningList);
        if (!_.isEmpty(newLearningList)) {
          let isAllCompleted = newLearningList.filter(
            (data) => data?.programprogress === "100"
          );
          if (isAllCompleted?.length === newLearningList?.length) {
            setIsAllCompleted(true);
          } else {
            newLearningList = newLearningList.filter(
              (data) => data.programprogress != "100"
            );
          }
        }
        setOnBoardingData(newLearningList);
        if (learningPathBroker.payload.payload.length === 0) {
          setNoData(true);
        }
        setApiCalled(false);
        setIsLoading(false);
        dispatch(getLearningPathBrokerClear());
      } else {
        setIsLoading(false);
      }
    }
  }, [learningPathBroker]);

  const getAssignedOBLP = () => {
    setIsLoading(true);
    dispatch(
      getLearningPathBroker({
        module: "getAllLearningPathBroker",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          broker_id: authBroker?.payload?.user?.broker_id,
          is_onboarding: true,
          assigned: 1,
        },
      })
    );
  };

  const getUnAssignedOBLP = () => {
    setIsLoading(true);
    dispatch(
      getUnAssginedOBLP({
        module: "getAllLearningPathBroker",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          broker_id: authBroker?.payload?.user?.broker_id,
          is_onboarding: true,
          assigned: 0,
        },
      })
    );
  };

  const showProgessNaming = (progres) => {
    if (progres === 0) {
      return "Not Started";
    } else if (progres === 100) {
      return "Completed";
    } else {
      return "In Progress";
    }
  };

  useEffect(() => {}, [isLoading]);

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      {/* {onBoardingData.length} */}
      <div className="New-dashboard learning">
        <section className="my_onbording pt-5g pb-5g">
          <div className="container">
            <div className="search_heading mb-4" id="myOnboard-div">
              <p className="lable-heading_search m-0">{t("myOnboarding")}</p>
            </div>
            {isLoading ? (
              <div className="simmerbox">
                <div className="container">
                  <div className="row videolistbox">
                    {[1, 2, 3, 4].map((i) => {
                      return <ShimmerCardBody key={`shimmer-${i}`} />;
                    })}
                  </div>
                </div>
              </div>
            ) : props.hideLine ? (
              <OnBoardingPageSection />
            ) : isAllCompleted ? (
              <div class="cup-container">
                <p class="cup-text">🏆 {t("Congratulations")}! 🏆</p>
                <p class="cup-texts">
                  {/* You have successfully completed your onboarding journey. We're
                  excited to have you on board and look forward to achieving
                  great things together! */}
                  {t("You've successfully completed all the assigned Onboarding Paths")}
                </p>
              </div>
            ) : onBoardingData && onBoardingData?.length > 0 ? (
              <>
                {onBoardingData.map((data, index) => {
                  return (
                    <div
                      className={`accordion-item ${index > 0 ? "mt-5" : ""}`}
                      key={`onboard-${index + 1}`}
                    >
                      <h2 className="accordion-header" id="headingOne">
                        <div className="d-flex mb-4 myOnboarding align-items-center">
                          <h3>{data?.programName}</h3>
                          {!props.hideLine && (
                            <div className="border_lines w-100">
                              <ProgressBar
                                className="progressbar"
                                variant="success"
                                now={data?.programprogress}
                              />
                            </div>
                          )}
                        </div>
                        {props.hideLine && (
                          <div className="container-pie">
                            <div className="container-chart">
                              <div className="box d-flex align-items-baseline mb-2">
                                <div
                                  className="chart-7"
                                  style={{
                                    width: 150,
                                    height: 150,
                                    position: "relative",
                                  }}
                                >
                                  <CircularProgressbar
                                    value={data.programprogress}
                                    text={`${data.programprogress}%`}
                                    styles={buildStyles({
                                      pathColor:
                                        96 < 100 ? `#6CC869` : "#6CC869", //FF9700=yellow
                                      trailColor: "#EBEBEB",
                                      textSize: "16px",
                                      text: {
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        fill: "#000",
                                        fontFamily: "Inter",
                                      },
                                    })}
                                  />
                                </div>
                                <p className="chart-content">
                                  {showProgessNaming(data.programprogress)}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </h2>

                      <div className="responsive-carousel">
                        {data?.courseList && data?.courseList.length > 0 ? (
                          <SliderCourseListing
                            isOnboarding={data.is_onboarding ? true : false}
                            coursesList={data.courseList}
                            setFavoriteCourse={() => {}}
                            closeModal={closeChildModal}
                            setCloseModal={setCloseChildModal}
                            hasDescription={false}
                            pageType="course"
                            showBlankCard={false}
                            path={props.hideLine ? "/my-onboarding" : "/home"}
                            id={data.programID}
                            isLP={true}
                          />
                        ) : (
                          <div className="col-md-12">
                            {t("No on boarding course found")}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                <div class="cup-container">
                  <p class="cup-text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 297 297"
                      width="120"
                      height="120"
                    >
                      <g id="SVGRepo_iconCarrier">
                        <g>
                          <path
                            fill-rule="evenodd"
                            class="s0"
                            d="m112.6 195.2l6.9 4c2.8 1.6 3.8 5.2 2.2 8l-13.1 22.6c-1.1 1.9-3 2.9-5.1 2.9-1 0-2-0.2-2.9-0.8l-6.9-3.9c-0.9-0.6-1.9-0.8-2.9-0.8-3.1 0-5.9 2.4-5.9 5.8v8c0 3.2-2.6 5.9-5.8 5.9h-26.1c-3.2 0-5.9-2.7-5.9-5.9v-8c0-3.4-2.8-5.8-5.8-5.8-1 0-2 0.2-3 0.8l-6.8 3.9c-1 0.6-2 0.8-3 0.8-2 0-4-1-5-2.9l-13.1-22.6c-1.6-2.8-0.6-6.4 2.2-8l6.8-4c4-2.2 4-7.9 0-10.1l-6.8-4c-2.8-1.6-3.8-5.2-2.2-8l13.1-22.6c1-1.9 3-2.9 5-2.9 1 0 2 0.2 3 0.8l6.8 3.9c1 0.6 2 0.8 3 0.8 3 0 5.8-2.4 5.8-5.8v-8c0-3.2 2.7-5.8 5.9-5.8h26.1c3.2 0 5.8 2.6 5.8 5.8v8c0 3.4 2.8 5.8 5.9 5.8 1 0 2-0.2 2.9-0.8l6.9-3.9c0.9-0.6 1.9-0.8 2.9-0.8 2.1 0 4 1 5.1 2.9l13.1 22.6c1.6 2.8 0.6 6.4-2.2 8l-6.9 4c-3.9 2.2-3.9 7.9 0 10.1zm-29.2-5c0-9.7-7.8-17.4-17.4-17.4-9.6 0-17.4 7.7-17.4 17.4 0 9.6 7.8 17.3 17.4 17.3 9.6 0 17.4-7.7 17.4-17.3z"
                            fill="#6941c6"
                          ></path>
                          <path
                            class="s1"
                            d="m108.1 23.7c-3.1-3.2-8.2-3.2-11.4 0-3.1 3.1-3.1 8.2 0 11.3l14.4 14.4c-52.9 2.7-95.7 44.2-100.3 96.5l1.2-2c3.4-5.9 9.7-9.6 16.5-9.6q0.3 0 0.5 0c9-37.7 41.9-66.2 81.8-68.7l-14.1 14.1c-3.1 3.1-3.1 8.2 0 11.4 1.6 1.5 3.7 2.3 5.7 2.3 2.1 0 4.1-0.8 5.7-2.3l28-28c1.5-1.6 2.4-3.6 2.4-5.7 0-2.2-0.9-4.2-2.4-5.7z"
                            fill="#2d2d2d"
                          ></path>
                          <path
                            class="s0"
                            d="m209.9 64.9c17.8 0 32.4-14.6 32.4-32.5 0-17.9-14.6-32.4-32.4-32.4-17.9 0-32.5 14.5-32.5 32.4 0 17.9 14.6 32.5 32.5 32.5z"
                            fill="#6941c6"
                          ></path>
                          <path
                            class="s2"
                            d="m273 152.3v-44.6c0-12.3-7.9-23.3-19.6-27.1h-0.1l-17.1-2.9c-1.5-0.4-3 0.3-3.6 1.8l-19.4 53.4c-1.2 3.1-5.5 3.1-6.6 0l-19.5-53.4c-0.4-1.2-1.5-1.9-2.7-1.9-0.3 0-18 3-18 3-11.8 3.9-19.7 14.9-19.7 27.2v44.5c0 6.6 5.4 12 12 12h102.3c6.6 0 12-5.4 12-12z"
                            fill="#dfdfdf"
                          ></path>
                          <path
                            class="s1"
                            d="m287.4 162.9c-0.7 9.2-8.3 14.9-17.5 15.6-7 40.4-41.2 71.6-83 74.2l14.1-14.1c3.1-3.1 3.1-8.2 0-11.4-3.1-3.1-8.2-3.1-11.4 0l-28 28c-3.1 3.2-3.1 8.3 0 11.4l28 28c1.6 1.6 3.6 2.4 5.7 2.4 2.1 0 4.1-0.8 5.7-2.4 3.1-3.1 3.1-8.2 0-11.3l-14.4-14.4c56-2.8 100.8-49.3 100.8-106z"
                            fill="#2d2d2d"
                          ></path>
                          <path
                            class="s0"
                            d="m216.9 77.1c-0.7-0.8-1.8-1.2-2.9-1.2h-8.3c-1.1 0-2.2 0.4-2.9 1.2-1.2 1.3-1.3 3.1-0.5 4.5l4.4 6.7-2.1 17.4 4.1 10.8c0.4 1.1 1.9 1.1 2.3 0l4.1-10.8-2.1-17.4 4.4-6.7c0.9-1.4 0.7-3.2-0.5-4.5z"
                            fill="#6941c6"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </p>
                  <p class="cup-texts">
                    <strong>
                      {t("You currently don't have an assigned onboarding path. Please contact your manager for further guidance.")}
                    </strong>
                  </p>
                </div>
              </>
            )}
          </div>
        </section>
      </div>{" "}
    </>
  );
};

export default OnBoardingSectionBroker;
